<template>
    <div>

        <form-input name="title"
                    :label="$t('label.title')"
                    :rules="{required: true, min: 5, max: 100}" v-model="props.data.title"/>

        <form-textarea name="preview_text"
                       :label="$t('label.preview_text')"
                       :help="$t('help.article.preview_text')"
                       :rows="2"
                       :rules="{required: true, min: 10, max: 150}" v-model="props.data.preview_text"/>

		<form-codearea v-model="props.data.content" name="content"
					   :label="$t('label.content')"
					   :rules="{required: true, min: 50}"
					   :disabled="props.disabled"/>

        <form-remote-select v-if="props.data.type" :action="'/v1/article-categories'"
                          :data="{type: props.data.type, club_id: props.data.club_id}"
                          :disabled="props.disabled"
                          :label="$t('label.category')"
                          v-model="props.data.category_id"
                          v-model:selected="selectedCategory"
                          :rules="{required: true}"
                          text-prop="title"
                          value-prop="id"
                          :placeholder="$t('placeholder.select')"/>

		<form-sport-type-select v-model="props.data.sport_type_id"
								name="sport_type_id"
								:disabled="props.disabled"
								multiple
								persistent
								orderable
								:help="$t('help.article.sport_type_id')"
								:placeholder="$t('placeholder.select')"
								:label="$t('label.sport_types')"/>

		<form-model-suggest-select v-model="props.data.links"
								   name="links"
								   :disabled="props.disabled"
								   multiple
								   :help="$t('help.article.links')"
								   :placeholder="$t('placeholder.select')"
								   :label="$t('label.linked_models')"/>

		<form-date-input
			time
			clearable
			even-minutes
			:placeholder="$t('label.immediately')"
			name="published_at"
			:label="$t('label.published_at')"
			:help="$t('help.article.published_at')"
			v-model="props.data.published_at"/>

		<client-only>
			<attach-cropped-image-form-inputs :title="$t('label.title_image')"
											  :subtitle="$t('help.article.cover_image')"
											  :data="props.data" prop="image" :ratio="16/9" help-size="2208x1242px" help-ratio="16/9"/>

			<row v-if="props.data.image">
				<column cols="12" sm="6">
					<form-input name="image_credits"
								:label="$t('label.image_credits')"
								:placeholder="$t('placeholder.image_credits')"
								:rules="{required: true, max: 75}" v-model="props.data.image_credits"/>
				</column>
				<column cols="12" sm="6">
					<form-input name="image_credits_url"
								:label="$t('label.image_credits_url')"
								:placeholder="$t('placeholder.without_link')"
								:rules="{max: 190}" v-model="props.data.image_credits_url"/>
				</column>
			</row>
		</client-only>

    </div>
</template>

<script setup lang="ts">

const props = defineProps<{

	// The data on which to store the input data
	data: { [key: string]: any },

	// Whether all inputs shall be disabled
	disabled?: boolean,

	// Whether the inputs are used to edit the resource
	edit?: boolean,
}>();

const selectedCategory = ref(null);

watch(() => props.data.type, (newValue) => {
	if (newValue && selectedCategory.value && selectedCategory.value.type?.value !== newValue) {
		props.data.category_id = null;
	}
});

</script>